export default __webpack_public_path__ + "static/media/1.5022e3f7.jpg";